import { render, staticRenderFns } from "./vip_agreement.vue?vue&type=template&id=df79c8c2&scoped=true&"
import script from "./vip_agreement.vue?vue&type=script&lang=js&"
export * from "./vip_agreement.vue?vue&type=script&lang=js&"
import style0 from "./vip_agreement.vue?vue&type=style&index=0&id=df79c8c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df79c8c2",
  null
  
)

export default component.exports